import { render, staticRenderFns } from "./AssignmentOptions.vue?vue&type=template&id=c953c2b8&scoped=true&"
import script from "./AssignmentOptions.vue?vue&type=script&lang=js&"
export * from "./AssignmentOptions.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentOptions.vue?vue&type=style&index=0&id=c953c2b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c953c2b8",
  null
  
)

export default component.exports